// extracted by mini-css-extract-plugin
export default {"control":"StaysCheckoutComplete_control__T0Zqh","row":"StaysCheckoutComplete_row__fnI1J","col":"StaysCheckoutComplete_col__fZJS9"};